/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_SupportInputs */

const en_dashboard_support = /** @type {(inputs: Dashboard_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support`)
};

const fr_dashboard_support = /** @type {(inputs: Dashboard_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support`)
};

/**
* | output |
* | --- |
* | "Support" |
*
* @param {Dashboard_SupportInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const dashboard_support = /** @type {((inputs?: Dashboard_SupportInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_SupportInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_support(inputs)
	return fr_dashboard_support(inputs)
});